<template>
  <div class="d-flex w-100 h-100">
    <Navbar />
    <div id="content" class="flex-grow-1 bg-light">
      <div class="container-fluid p-4 position-relative bg-light">
        <div class="pb-4 d-flex flex-column justify-content-between">
          <small class="text-muted mb-1"
            ><font-awesome-icon icon="chart-line" fixed-width class="mr-1" />{{
              $t("global.umsatzauswertung")
            }}</small
          >
          <h1 class="h2">{{ $t("vizrt.titel") }}</h1>
        </div>
        <div>
          <b-card no-body class="shadow-sm flex-grow-1" v-if="dataAvailable">
            <div
              class="d-flex flex-column justify-content-center p-3 align-items-center border-bottom"
            >
              <b-form-datepicker
                v-model="selectedDate"
                class="w-25"
                min="2019-01-01"
                :max="today"
              ></b-form-datepicker>
            </div>
            <b-tabs pills card vertical>
              <b-tab
                no-body
                :title="`${element}`"
                v-for="(element, index) in kundenbetreuer"
                :key="`tab-${index}`"
                @click="changeVertriebler(element)"
              >
                <VizrtKundenumsaetzeTabelle
                  :selected-date="selectedDate"
                  :vertriebler="selectedVertriebler"
                  :key="tableView"
                />
              </b-tab>
            </b-tabs>
          </b-card>
          <div v-else>
            <b-card bg-variant="warning" style="text-align: center"
              >Keine Datengrundlage vorhanden!</b-card
            >
          </div>
        </div>
      </div>
    </div>
    <b-button
      variant="danger"
      class="btn"
      v-on:click="$bvModal.show('delete-modal')"
      v-show="isAdmin"
      v-if="dataAvailable"
    >
      <span v-if="!loadingDelete"> Datengrundlage löschen </span>
      <span v-else>
        <b-spinner variant="white" type="grow"></b-spinner>
      </span>
    </b-button>
    <b-modal
      id="delete-modal"
      title="Wirklich löschen?"
      cancel-title="Abbrechen"
      @cancel="$bvModal.hide('delete-modal')"
      @ok="deleteAllData()"
    >
      <p>Soll die gesamte Datengrundlage wirklich gelöscht werden?</p>
      <p>Dieser Schritt ist endgültig und kann nicht widerrufen werden!</p>
    </b-modal>
    <b-button
      class="btn"
      v-on:click="$bvModal.show('upload-modal')"
      v-show="isAdmin"
      v-if="!dataAvailable"
      >Daten hochladen</b-button
    >
    <b-modal
      id="upload-modal"
      title="Daten hochladen"
      @ok="$bvModal.hide('upload-modal')"
      ok-title="Abbrechen"
      ok-variant="secondary"
      ok-only
    >
      <VizrtListUpload
        @finished="
          $bvModal.hide('upload-modal');
          forceRerender();
        "
      />
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import Navbar from "../Navbar.vue";
import VizrtKundenumsaetzeTabelle from "./VizrtKundenumsaetzeTabelle.vue";
import VizrtListUpload from "./VizrtListUpload.vue";
import { collection, deleteDoc, getDocs, doc } from "firebase/firestore";
import { firestore } from "../../firebase";

export default {
  name: "VizrtOverviewView",
  components: {
    Navbar,
    VizrtKundenumsaetzeTabelle,
    VizrtListUpload,
  },
  methods: {
    toggleModal() {
      return this.showUploadModal === true
        ? (this.showUploadModal = false)
        : (this.showUploadModal = true);
    },
    changeVertriebler(vertriebler) {
      this.selectedVertriebler = vertriebler.replaceAll(" ", "_");
    },
    async deleteAllData() {
      try {
        this.loadingDelete = true;
        const colRefReseller = collection(firestore, "vizrtReseller");
        const snapshotReseller = await getDocs(colRefReseller);
        for (const document of snapshotReseller.docs) {
          await deleteDoc(doc(firestore, "vizrtReseller", document.id));
        }
        const colRefVertriebler = collection(firestore, "vizrtVertriebler");
        const snapshotVertriebler = await getDocs(colRefVertriebler);
        for (const document of snapshotVertriebler.docs) {
          await deleteDoc(doc(firestore, "vizrtVertriebler", document.id));
        }
        this.loadingDelete = false;
        this.forceRerender();
      } catch (err) {
        console.log(err);
        this.loadingDelete = false;
      }
    },
    async forceRerender() {
      this.tableView += 1;
      this.kundenbetreuer = [];
      const colRefVertriebler = collection(firestore, "vizrtVertriebler");
      const snapshotVertriebler = await getDocs(colRefVertriebler);
      if (snapshotVertriebler.docs.length === 0) {
        this.dataAvailable = false;
      } else {
        this.dataAvailable = true;
        snapshotVertriebler.docs.forEach((item) => {
          this.kundenbetreuer.push(item.id.replaceAll("_", " "));
        });
        this.selectedVertriebler = this.kundenbetreuer[0];
      }
    },
  },
  watch: {
    "$store.state.isAdminVizrt": function (val) {
      this.isAdminVizrt = val;
    },
  },
  computed: {
    isAdmin() {
      return this.$store.state.isAdminVizrt;
    },
  },
  data() {
    return {
      kundenbetreuer: [],
      selectedDate: moment().format("YYYY-MM-DD"),
      today: moment().format("YYYY-MM-DD"),
      showUploadModal: false,
      selectedVertriebler: "",
      isAdminVizrt: false,
      loadingDelete: false,
      loadingUpload: false,
      dataAvailable: undefined,
      tableView: 0,
    };
  },
  async mounted() {
    this.$store.dispatch("fetchIsAdmin");
    const colRefVertriebler = collection(firestore, "vizrtVertriebler");
    const snapshotVertriebler = await getDocs(colRefVertriebler);
    if (snapshotVertriebler.docs.length === 0) {
      this.dataAvailable = false;
    } else {
      this.dataAvailable = true;
      snapshotVertriebler.docs.forEach((item) => {
        this.kundenbetreuer.push(item.id.replaceAll("_", " "));
      });
      this.selectedVertriebler = this.kundenbetreuer[0];
    }
  },
};
</script>

<style scoped>
.center {
  display: flex;
  justify-content: center;
  gap: 32px;
}
.btn {
  position: absolute;
  top: 96px;
  right: 24px;
  width: 215px;
}
</style>
